'use client'

import { useRouter } from 'next/navigation'
import type { Locale } from '@/lib/i18n'

const LABELS: Partial<Record<Locale, string>> = {
  en: 'EN',
  hy: 'HY',
  ru: 'RU',
}

export function LanguageSwitcher({ current }: { current: Locale }) {
  const router = useRouter()

  function switchTo(locale: Locale) {
    document.cookie = `goris-locale=${locale};path=/;max-age=31536000;samesite=lax`
    router.refresh()
  }

  return (
    <div className="lang-sw" role="group" aria-label="Language">
      {(Object.keys(LABELS) as Locale[]).map(locale => (
        <button
          key={locale}
          type="button"
          className={`lang-btn${locale === current ? ' lang-btn--on' : ''}`}
          onClick={() => switchTo(locale)}
          aria-pressed={locale === current}
        >
          {LABELS[locale]}
        </button>
      ))}
    </div>
  )
}
